// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"54013464","389":"c6b95db7","732":"497ede0d","977":"6330ad81"}[chunkId] + ".chunk.js";
};